import { gql } from '@apollo/client'

export type EmpoloyeeType = {
  lastName: string
  userId: string
  firstName: string
  country: string
  emailAddress?: string
  employeeNumber: number
  phoneNumber: string
  tenantId: string
  tenantDealOverrideFlag: string
  federalAccessFlag: string
}
export type EmployeeWithPhFlagType = {
  lastName: string
  userId?: string
  firstName: string
  country: string
  emailAddress?: string
  employeeNumber: number
  phoneNumber: string
  tenantId: string
  tenantDealOverrideFlag: string
  federalAccessFlag: string
  hasPhAccess: string
}
export interface IEmployeeLookupWithPhFlagResponse {
  employeeListWithPhFlag: {
    didError: boolean
    errorCode: any
    errorMessage: string
    infoMessage: string
    employees: EmployeeWithPhFlagType[]
  }
}

export interface IEmployeeLookupResponse {
  employeeList: {
    didError: boolean
    errorCode: any
    errorMessage: string
    employees: EmpoloyeeType[]
  }
}

export interface IEmployeeLookupRequest {
  employeeSearchRequest: {
    emailAddresses?: string[]
    employeeNumbers?: number[]
    userId?: string
    searchKey: string
    sortBy?: string
  }
}

const EMPLOYEE_LOOKUP = gql`
  query employeelist($employeeSearchRequest: EmployeeSearchRequestInput!) {
    employeeList(employeeSearchRequest: $employeeSearchRequest) {
      didError
      errorCode
      errorMessage
      employees {
        lastName
        userId
        firstName
        country
        emailAddress
        employeeNumber
        phoneNumber
        tenantId
        tenantDealOverrideFlag
        federalAccessFlag
      }
    }
  }
`

const EMPLOYEE_LOOKUP_WITH_PH_FLAG = gql`
  query employeeListWithPhFlag($employeeSearchRequest: EmployeeSearchRequestInput!) {
    employeeListWithPhFlag(employeeSearchRequest: $employeeSearchRequest) {
      didError
      errorCode
      errorMessage
      infoMessage
      employees {
        lastName
        firstName
        country
        emailAddress
        employeeNumber
        phoneNumber
        tenantId
        tenantDealOverrideFlag
        federalAccessFlag
        hasPhAccess
        __typename
      }
      __typename
    }
  }
`

export default EMPLOYEE_LOOKUP
export { EMPLOYEE_LOOKUP_WITH_PH_FLAG }
